document.addEventListener("DOMContentLoaded", function() {
  
  // Run only on homepage
  if (window.location.pathname === "/" || window.location.pathname === "/index.html") {
    
    const heading = document.querySelector(
      'h1.title.title-wrapper--no-top-margin.inline-richtext.h2.scroll-trigger.animate--slide-in'
    );

    if (heading) {
      const p = document.createElement("p");

      // Copy classes
      p.className = heading.className;

      // Copy inner content
      p.innerHTML = heading.innerHTML;

      // Replace element
      heading.parentNode.replaceChild(p, heading);
    }
  }

});

function replaceHeadings() {
  const selectors = [
    'h2.product-count__text.text-body',
    'h2.facet-filters__label',
    'h2.mobile-facets__heading'
  ];

  selectors.forEach(function(selector) {
    document.querySelectorAll(selector).forEach(function(heading) {
      if (heading.tagName.toLowerCase() === 'h2') {
        const p = document.createElement('p');
        p.className = heading.className;
        p.innerHTML = heading.innerHTML;
        heading.replaceWith(p);
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  replaceHeadings();

  const observer = new MutationObserver(replaceHeadings);
  observer.observe(document.body, { childList: true, subtree: true });
});

// Product Grid H3 to p
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('h3.card__heading.h5').forEach(function(heading) {

    const p = document.createElement('p');
    p.className = heading.className;
    p.innerHTML = heading.innerHTML;

    // Preserve ID if exists
    if (heading.id) {
      p.id = heading.id;
    }

    heading.replaceWith(p);

  });

});
function replaceCardHeadings() {
  document.querySelectorAll('h3.card__heading').forEach(function (heading) {

    if (heading.tagName.toLowerCase() === 'h3') {

      const p = document.createElement('p');

      // Copy classes
      p.className = heading.className;

      // Copy content
      p.innerHTML = heading.innerHTML;

      // Preserve ID if exists
      if (heading.id) {
        p.id = heading.id;
      }

      heading.replaceWith(p);
    }

  });
}

document.addEventListener("DOMContentLoaded", function () {

  replaceCardHeadings();

  // Re-run if Shopify reloads sections (filters / load more)
  const observer = new MutationObserver(replaceCardHeadings);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

document.addEventListener("DOMContentLoaded", function () {

  const heading = document.querySelector(
    'h1.title.title-wrapper--no-top-margin.inline-richtext.h1.scroll-trigger.animate--slide-in'
  );

  if (!heading) return;

  const currentPath = window.location.pathname;

  // Keep H1 only on contact-us page
  if (currentPath !== "/pages/contact-us") {

    const p = document.createElement("p");
    p.className = heading.className;
    p.innerHTML = heading.innerHTML;

    heading.replaceWith(p);
  }

});


